
(() => {
  const dayMs = 86400000;
  function todayCalifornia(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const values = Object.fromEntries(parts.map(p => [p.type, p.value]));
    return `${values.year}-${values.month}-${values.day}`;
  }
  function calendarDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    const d = new Date(value + 'T00:00:00Z');
    return Number.isFinite(d.getTime()) && d.toISOString().slice(0,10) === value ? d : null;
  }
  function calculate(start, today) {
    const s = calendarDate(start), n = calendarDate(today);
    if (!s || !n) return null;
    const due = new Date(s.getTime() + 100 * dayMs);
    return { due: due.toISOString().slice(0,10), days: Math.round((due - n) / dayMs) };
  }
  function init(root) {
    if (root.dataset.payoffReady) return;
    root.dataset.payoffReady = 'true';
    const input = root.querySelector('[data-payoff-start]');
    const date = root.querySelector('[data-payoff-date]');
    const status = root.querySelector('[data-payoff-status]');
    let followsToday = true;
    function render() {
      const today = todayCalifornia();
      if (followsToday) input.value = today;
      const result = calculate(input.value, today);
      if (!result) { date.textContent = 'Choose a valid start date'; status.textContent = ''; return; }
      date.textContent = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(calendarDate(result.due));
      status.textContent = input.value > today ? 'Example for a future agreement start date.' : result.days > 0 ? `${result.days} calendar days until this estimated date.` : result.days === 0 ? 'This estimated date is today. Confirm your payoff with Snap.' : 'This estimated date has passed. Contact Snap for current payoff options.';
    }
    input.addEventListener('input', () => { followsToday = false; render(); });
    root.querySelector('[data-payoff-reset]').addEventListener('click', () => { followsToday = true; render(); });
    const timer = setInterval(() => { if (!root.isConnected) clearInterval(timer); else render(); }, 30000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden && root.isConnected) render(); });
    render();
  }
  function boot(scope = document) { scope.querySelectorAll('[data-snap-calculator]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
